import axios from "axios";
import store from '../../app/store';
import { refreshToken } from '../auth/authSlice';
const baseURL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

const api = axios.create({
  baseURL: `${baseURL}/api`,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    // console.log('Interceptor caught error:', error.response?.status, error.response?.data);
    console.log(error.response.data[0].message)
    
    // Format error for Redux
    const formattedError = {
      message: error.response?.data?.message || error.message || 'An error occurred',
      status: error.response?.status,
      data: error.response?.data
    };
    
    // Don't intercept login-related requests
    if (error.config.url.includes('/auth/login') || error.config.url.includes('/auth/refresh-token')) {
      return Promise.reject(formattedError);
    }
    
    // Check if error message contains JWT-related text
    const errorMessage = error.response?.data[0]?.message?.toLowerCase() || '';
    const isJwtError = errorMessage.includes('jwt expired') || errorMessage.includes('jwt');
    
    // If it's a token-related error or JWT error, handle it appropriately
    if (error.response?.status === 401 || 
        error.response?.status === 500 || 
        isJwtError ||
        (error.response?.status === 400 && error.response.data[0].message === "Invalid token") ||
        error.response?.data?.message === "Invalid refresh token") {
      
      console.log('Token error detected, attempting refresh...');
      
      const originalRequest = error.config;
      
      // Only attempt refresh if we haven't tried before
      if (!originalRequest._retry) {
        originalRequest._retry = true;
        isRefreshing = true;

        try {
          const refreshTokenValue = localStorage.getItem('refreshToken');
          if (!refreshTokenValue) {
            throw new Error('No refresh token available');
          }

          const response = await api.post('/auth/refresh-token', null, {
            headers: { Authorization: `Bearer ${refreshTokenValue}` }
          });

          const { accessToken, refreshToken } = response.data;
          localStorage.setItem('accessToken', accessToken);
          localStorage.setItem('refreshToken', refreshToken);

          processQueue(null, accessToken);
          originalRequest.headers.Authorization = `Bearer ${accessToken}`;
          return api(originalRequest);
        } catch (err) {
          console.log('Refresh token failed:', err.response?.status, err.response?.data);
          processQueue(err, null);
          
          // Only clear storage and redirect if we're not already on the login page
          if (window.location.pathname !== '/login') {
            localStorage.clear();
            window.location.replace('/login');
          }
          return Promise.reject(formattedError);
        } finally {
          isRefreshing = false;
        }
      }
    }

    return Promise.reject(formattedError);
  }
);

export default api;